import { FormProvider } from 'react-hook-form';
import FormBuilderWithLayout from '@/components/company/FormBuilderWithLayout';

export const TrainForm = ({
  formControl,
  formRef,
  fields,
  formMode,
  handleSave,
  resetForm,
}: any) => (
  <FormProvider {...formControl}>
    <form ref={formRef} onSubmit={formControl.handleSubmit(handleSave)} className="mt-4">
      <FormBuilderWithLayout
        description={formMode === 'add' ? 'Create Training' : 'Edit Training'}
        fields={fields}
        onSubmit={formControl.handleSubmit(handleSave)}
        onCancel={resetForm}
        submitLabel={formMode === 'add' ? 'Save' : 'Update'}
        cancelLabel="Cancel"
        showPublishButton
      />
    </form>
  </FormProvider>
);
